import * as React from 'react';
import { connect } from 'react-redux';
import * as moment from 'moment';
import { find, debounce } from 'lodash';
import { push } from 'react-router-redux';
import {
  Icon,
  Notification,
  Tag,
  Tooltip,
  DateTime,
  Form,
  Pagination,
  Box,
} from '../';
import { getBookingsWithPaymentStatus } from '../../redux/actions/bookings';
import PAGINATE from '../../data/paginate';
import Loader from '../Loader/Loader';

interface Props {
  status: any;
  paymentStatus: any;
  bookings: any;
  dispatch: Function;
  vehicleTypes: any;
  company_id: any;
}

interface State {
  isLoading: boolean;
  page: number;
  order: string;
  sort: 'ASC' | 'DESC';
  search: string;
  bookings: Array<any>;
  isBookingView: boolean;
}

class PendingAccountPaymentTable extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      page: 0,
      order: 'return_date',
      sort: 'ASC',
      search: '',
      bookings: [],
      isBookingView: !!this.props.company_id,
    };
    this.handleUpdate = this.handleUpdate.bind(this);
    this.renderItem = this.renderItem.bind(this);
  }

  /**
   * Load vehicle types and bookings from API
   */
  async componentDidMount() {
    await this.handleUpdate();
  }

  /**
   * Fetch COMPLETE bookings with pending account payment
   */
  async handleUpdate() {
    const response = await this.props.dispatch(
      getBookingsWithPaymentStatus(
        2,
        this.state.page,
        'COMPLETE',
        this.state.order,
        this.state.sort,
        undefined,
        undefined,
        this.state.search,
        this.props.company_id,
      ),
    );
    const bookings = response.data.map((booking) => {
      booking.vehicleType = find(this.props.vehicleTypes, {
        id: Number(booking.vehicle_type_id),
      });
      booking.duration =
        1 + moment(booking.end).diff(moment(booking.start), 'd');
      return booking;
    });
    this.setState({
      bookings,
      isLoading: false,
    });
  }

  /**
   * Render an individual booking payment item
   * @param {Object} booking
   */
  renderItem(booking, index) {
    return (
      <tr
        key={index}
        onClick={() =>
          this.props.dispatch(
            push(
              `/payments/pending-account/${
                this.props.company_id
                  ? this.props.company_id
                  : booking.company_id
              }${this.state.isBookingView ? `/${booking.id}` : ''}`,
            ),
          )
        }
      >
        <td>
          {this.state.isBookingView ? (
            <div className="media">
              <div className="media-left">
                <Tag type="dark">{booking.invoiceId}</Tag>
              </div>
              <div className="media-content">
                {booking.contact_name || 'Unknown Contact'}
                <Tooltip
                  text={`${booking.vehicleType.name} for ${
                    booking.duration
                  } day${booking.duration !== 1 ? 's' : ''}, from
                      ${moment(booking.start).format('DD/MM/YY')} to
                      ${moment(booking.end).format('DD/MM/YY')}`}
                >
                  <Icon icon="info-circle has-text-grey-light" />
                </Tooltip>
              </div>
            </div>
          ) : (
            booking.name || 'N/A'
          )}
        </td>
        <td>£{Number(booking.total_cost).toFixed(2)}</td>
        <td>
          <DateTime date={booking.return_date} />
        </td>
      </tr>
    );
  }

  render() {
    const headings = [
      {
        title: this.state.isBookingView ? 'Booking' : 'Company',
        value: this.state.isBookingView ? 'id' : 'contact_name',
        sortable: true,
      },
      { title: 'Amount', value: 'total_cost', sortable: true },
      {
        title: this.state.isBookingView ? 'Return Date' : 'First Returned',
        value: 'return_date',
        sortable: true,
      },
    ];
    return (
      <div className="payment-table">
        {!this.state.isBookingView && (
          <div className="field">
            <Form
              type="search"
              fields={[{ name: 'search', type: 'text' }]}
              hasButton={false}
              handleChange={debounce(({ search }) => {
                this.setState({ search, page: 0, isLoading: true }, () =>
                  this.handleUpdate(),
                );
              }, 200)}
            />
          </div>
        )}
        {this.state.isLoading ? (
          <Loader fullwidth />
        ) : this.state.bookings.length === 0 ? (
          <Notification type="default">Nothing found</Notification>
        ) : (
          <Box>
            <table>
              <thead>
                <tr>
                  {headings.map((heading) => (
                    <th key={heading.value}>
                      {heading.sortable ? (
                        <a
                          className={
                            this.state.order === heading.value
                              ? 'is-active'
                              : 'has-text-grey'
                          }
                          onClick={() => {
                            const newState: any = {
                              order: heading.value,
                              sort: 'ASC',
                              isLoading: true,
                            };
                            if (this.state.order === heading.value) {
                              newState.sort =
                                this.state.sort === 'ASC' ? 'DESC' : 'ASC';
                            }
                            this.setState(newState, this.handleUpdate);
                          }}
                        >
                          <div className="level is-mobile">
                            <div className="level-left">
                              <div className="level-item">
                                <small>{heading.title}</small>
                              </div>
                            </div>
                            <div className="level-right">
                              <div className="level-item">
                                <Icon
                                  size="small"
                                  icon={`sort-amount-${
                                    this.state.order === heading.value &&
                                    this.state.sort === 'DESC'
                                      ? 'desc'
                                      : 'asc'
                                  }`}
                                />
                              </div>
                            </div>
                          </div>
                        </a>
                      ) : (
                        heading.title
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {console.log(this.state.bookings, 'bookings')}
                {this.state.bookings.map((booking, index) => {
                  if (index >= PAGINATE.payments.MAX) {
                    return null;
                  }
                  if (
                    Number(
                      (booking.total_cost - booking.total_paid).toFixed(2),
                    ) === 0
                  ) {
                    return null;
                  }
                  return this.renderItem(booking, index);
                })}
              </tbody>
            </table>
            <Pagination
              page={this.state.page}
              lastPage={this.state.bookings.length <= PAGINATE.payments.MAX}
              handleUpdate={(page) => {
                this.setState({ page, isLoading: true }, () => {
                  this.handleUpdate();
                });
              }}
            />
          </Box>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ vehicleTypes }) => ({
  vehicleTypes: vehicleTypes.vehicleTypes,
});

export default connect(mapStateToProps)(PendingAccountPaymentTable);
